function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.555 11.13H3.952V7.5L0 8.34v4.155c0 .664.27 1.302.75 1.771.48.47 1.13.734 1.808.734h9.391c.679 0 1.33-.264 1.81-.734s.749-1.107.749-1.771V0h-3.953V11.13zM24.706 0h-3.952v15h3.952V0zM36.02 0l6.802 8.085L49.623 0h3.952v15h-3.952V5.7l-6.389 7.71H42.407L36.02 5.7V15h-3.953V0h3.953zm35.353 8.085L64.57 0h-3.937v15h3.937V5.7l6.388 7.71H71.8l6.374-7.71V15h3.952V0h-3.952l-6.802 8.085zM91.598 0l4.535 5.415L100.668 0h5.453l-8.012 8.295V15h-3.952V8.295L86.144 0h5.454zm29.842 11.13h-6.542V7.5l-3.937.885v4.11a2.46 2.46 0 00.69 1.724 2.566 2.566 0 001.715.781h9.406c.679 0 1.33-.264 1.81-.734.479-.47.749-1.107.749-1.771V0h-3.891V11.13zM138.809 0h3.753l8.564 15h-3.906l-1.685-3.12h-9.698L134.121 15h-3.906l8.594-15zm-.934 8.28H143.482l-2.804-4.815-2.803 4.815zM161.777 0h-4.519v3.63h9.023l-10.019 8.76V15h16.882v-3.63h-10.203l10.203-8.76V0h-11.367zm29.703 0h4.519v2.61l-10.203 8.76h10.203V15H179.102v-2.61l10.019-8.76h-9.008V0h11.367z",
  fill: "#1A1A1A"
});

function SvgJimmyjazzLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 196 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgJimmyjazzLogoinline;